import React from "react";
import css from "./CheckBoxList.module.css";

const CheckBoxList = ({ children }) => {
  if (!children) return null;

  const {
    label,
    name,
    checkboxes = [],
    onCheckboxChange,
  } = children;

  if (!checkboxes.length) return null;

  return (
    <div className={css.CheckBoxList}>
      {label && <p className={css.Label}>{label}</p>}

      <div className={css.Options}>
        {checkboxes.map((opt) => (
          <label key={opt.name} className={css.Option}>
            <input
              type="checkbox"
              name={name}
              value={opt.name}
              checked={opt.isChecked}
              onChange={(e) =>
                onCheckboxChange?.(opt.name, e.target.checked)
              }
            />
            <span className={css.Text}>{opt.label}</span>
          </label>
        ))}
      </div>
    </div>
  );
};

export default CheckBoxList;
